import i18n from './i18n'

// Export a promise that resolves when i18n is ready
export const i18nReady = new Promise<void>((resolve) => {
  if (i18n.isInitialized) {
    resolve()
  } else {
    i18n.on('initialized', () => {
      resolve()
    })
  }
})